import axios from "axios";
import cookie from "react-cookies";
/**
 * URL to send request
 */
const url = process.env.React_App_Api_url;
// const url = "http://localhost:5000/user";

// Place Order
export const placeOrder = (uid, aid, vid, data) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${url}/placeOrderv2`, data, { headers: { uid, aid, vid } })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || Object.keys(err)))
  );

// Order Details
export const getOrderDetailsRashan = (user) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${url}/getPastOrderStatusRashanStage`, {
        headers: {
          id: user,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || " Server Offline"))
  );

//
export const getOrderDetailsRashanStore = (phnNumber) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${url}/getOrderDetailsRashanStore`, {
        headers: {
          mobile: phnNumber,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || " Server Offline"))
  );

//
export const getPastOrderStatusRashan = (user) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${url}/getPastOrderStatusRashan`, {
        headers: {
          id: user,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || " Server Offline"))
  );

// Order Details
export const fetchOrderDetails = (id) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${url}/orderStage/${id}`, { headers: { id: cookie.load("uid") } })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || " Server Offline"))
  );
export const fetchStoreOrderDetails = (id) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${url}/orderStageStore/${id}`, { headers: { id: cookie.load("uid") } })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || " Server Offline"))
  );

// Cancel an order
export const cancelOrder = (data) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${url}/cancelOrder`, { ...data, userId: cookie.load("uid") })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || " Server Offline"))
  );

// Get Discount Coupons
export const getDiscountCoupons = (uid, vid) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${url}/getDiscountCoupons`, { headers: { uid, vid } })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || Object.keys(err)))
  );

//Get coupon
export const getCoupon = (coupon_id) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${url}/getCoupon`, {
        headers: { id: cookie.load("uid"), coupon_id },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || Object.keys(err)))
  );
